import styled from 'styled-components';

export const StatusContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StatusCircle = styled.span<{ isAlert: boolean }>`
  display: inline-block;
  width: 22px;
  height: 22px;
  border-radius: 50%;

  background-color: ${({ isAlert }) => (isAlert ? '#e53935' : '#43a047')};
`;
